import { gql } from '@apollo/client';

import {
  WITH_COUNT_VARIABLES,
  WITH_COUNT_ARGUMENTS
} from '../../queries/withCount';

import { CORE_ASSET_FIELDS } from 'app/src/components/Assets/queries';

const ERRORS = `errors { path, message }`;

const FEE_FIELDS = `
  id
  type
  buyerFee
  asset {
    ${CORE_ASSET_FIELDS}
    seller { id, name, inspectionFeeAmount }
  }
  saleAsset { id }
  amount
  description
  acceptedBy { id, fullName }
  acceptedByMethod
  createdAt
  createdByName
  feeFiles { id, filename, contentType, url}
  linkedAttachments { id, name, url, resourceId, resourceType }
  feeEstimate {
    id
    acceptedByString
    acceptMethod
    acceptedAt
  }
  invoiceStatus
  invoiceTxn { id, reference }
`

const FEE_VARIABLES = `
  $type: String!
  $buyerFee: Boolean!
  $assetId: ID!
  $saleAssetId: ID
  $expenseId: ID
  $amount: Decimal!
  $description: String!
  $acceptedById: ID
  $acceptedByMethod: String
  $invoiceId: ID
`;

const FEE_ARGUMENTS = `
  type: $type
  buyerFee: $buyerFee
  assetId: $assetId
  saleAssetId: $saleAssetId
  expenseId: $expenseId
  amount: $amount
  description: $description
  acceptedById: $acceptedById
  acceptedByMethod: $acceptedByMethod
  invoiceId: $invoiceId
`;

const FEE_FIELDS_AND_ERRORS = `
  fee {
    ${FEE_FIELDS}
  }
  ${ERRORS}
`;

export const FEES_WITH_COUNT = gql`
  query (
    ${WITH_COUNT_VARIABLES}
    $assetId: ID
  ) {
    feesWithCount(
      ${WITH_COUNT_ARGUMENTS}
      assetId: $assetId
    ) {
      entries {
        ${FEE_FIELDS}
      }
      count
    }
  }
`;

export const CREATE_FEE = gql`
  mutation CreateFee(
    ${FEE_VARIABLES}
  ) {
    createFee(
      ${FEE_ARGUMENTS}
    ) {
      fee { id, type, amount }
      errors { path, message }
    }
  }
`;

export const UPDATE_FEE = gql`
  mutation UpdateFee(
    $id: ID!
    ${FEE_VARIABLES}
    $feeFiles: [Upload!]
    $linkedAttachmentAttributes: [LinkedAttachmentInput!]
  ) {
    updateFee(
      id: $id
      ${FEE_ARGUMENTS}
      feeFiles: $feeFiles
      linkedAttachmentAttributes: $linkedAttachmentAttributes
    ) {
      ${FEE_FIELDS_AND_ERRORS}
    }
  }
`;

export const FEE = gql`
  query Fee($id: ID!) {
    fee(id: $id) {
      ${FEE_FIELDS}
    }
  }
`;

export const HIDE_FEE = gql`
  mutation HideFee($id: ID!) {
    hideFee(id: $id) {
      fee {
        id
      }
      errors {
        message
        path
      }
    }
  }
`;

export const SELECTS = gql`
  query SelectOptions {
    users {
      id
      fullName
    }
  }
`

